import React from 'react';
import { useSelector } from 'react-redux';
import Icon from '@app/components/Icon/index';
import {isIe9} from '@app/helpers';

interface IBranding {
    imageUrl?: string;
    color?: any;
}
interface IProps {
    color?: 'White';
    size?: 'small';
}

export const CompanyLogo = ({ color, size }: IProps) => {
    const branding: IBranding = useSelector((state: any) => state.basic.shellConfig.branding);
    const loading: boolean = useSelector((state: any) => state.basic.shellConfigLoading);
    const icon: any = color ? `passlyLogo${color}Ico` : `passlyLogoIco`;
    const iconClassName: any = size === 'small' ? `login__logo-icon-small` : '';

    if (isIe9()) {
        return <div className='navbar__logo--branding'>
            <img className='navbar__logo--img' alt='Passly Logo' src='static/media/passly-logo-blue.svg' />
        </div>;
    }

    return !loading && branding !== null && branding !== undefined && branding.imageUrl !== null ? (
        <div className='navbar__logo--branding'>
            <img className='navbar__logo--img' alt='Logo' src={branding.imageUrl} />
        </div>
    ) : (
        <Icon icon={icon} className={`login__logo-icon ${iconClassName}`} viewBox='0 0 203 50' />
    );
};
